import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import LecturaForm from './LecturaForm';
import Swal from 'sweetalert2';

const EditLecturaModal = ({ show, handleClose, lectura, setLectura, handleSave }) => {
    useEffect(() => {
        if (show && lectura) {
            // Evitar bucles asegurando que solo actualice cuando hay diferencias
            setLectura((prevLectura) => {
                const isDifferent =
                    prevLectura.level !== lectura.level ||
                    prevLectura.nombre !== lectura.nombre ||
                    prevLectura.descripcion !== lectura.descripcion ||
                    JSON.stringify(prevLectura.evaluations) !== JSON.stringify(lectura.evaluations) ||
                    JSON.stringify(prevLectura.freeResponseEvaluation) !== JSON.stringify(lectura.freeResponseEvaluation);
    
                if (isDifferent) {
                    return {
                        id: lectura.id, // Incluimos siempre el ID
                        level: lectura.level || '',
                        nombre: lectura.nombre || '',
                        descripcion: lectura.descripcion || '',
                        columnas: lectura.columnas || '1',
                        evaluations: lectura.evaluations || [],
                        freeResponseEvaluation: lectura.freeResponseEvaluation || { title: '', description: '' },
                    };
                }
    
                return prevLectura; // Retornar el estado previo si no hay cambios
            });
        }
    }, [show, lectura, setLectura]);
    

    const handleFormSubmit = async (event) => {
        if (event && event.preventDefault) {
            event.preventDefault();
        }

        try {
            await handleSave(lectura); // Guardar los cambios
            Swal.fire({
                icon: 'success',
                title: 'Cambios guardados con éxito',
                showConfirmButton: false,
                timer: 2000,
            });
            handleClose(); // Cierra el modal
        } catch (error) {
            console.error('Error al guardar los cambios:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron guardar los cambios. Inténtalo nuevamente.',
            });
        }
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            enforceFocus
            backdrop="static"
            keyboard={false}
            size="xl"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Editar Lectura</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <LecturaForm
                    lectura={lectura}
                    setLectura={setLectura}
                    handleSubmit={handleFormSubmit}
                    buttonText="Guardar Cambios"
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditLecturaModal;
